import React from "react";
import AdminServiceTickets from "../../components/dashboard/AdminServiceTickets";

const AdminDomiciliation = () => (
  <AdminServiceTickets
    serviceCode="domiciliation"
    title="Domiciliation"
    lead="Les demandes des entreprises domiciliées chez Platform98."
  />
);

export default AdminDomiciliation;
